// extracted by mini-css-extract-plugin
module.exports = {"screenCards":"AppSetting_screenCards__1tl2Z","flex":"AppSetting_flex__3INPs","screenCard":"AppSetting_screenCard__1LFIT","screenCardTitle":"AppSetting_screenCardTitle__p6pY3"};